import { useContext } from "react"
import AppInfoContext from "src/provider/state-manager/appInfoProvider"
const SvgComponent = (props:any) => {
    const {info: {theme}} = useContext(AppInfoContext)
return(
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={40}
    height={40}
    fill="none"
    {...props}
  >
    <rect width={40} height={40} fill={theme["#B4E3E1"]} rx={20} />
    <path
      stroke= { theme["#0D968F"]}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.667}
      d="M18.333 16.669a1.874 1.874 0 0 1 3.641.624c0 1.25-1.873 1.874-1.873 1.874m.024 2.5h.008M15.833 25v1.946c0 .444 0 .666.091.78.08.1.2.157.326.157.146 0 .32-.139.666-.416l1.988-1.59c.406-.325.61-.488.836-.603a2.5 2.5 0 0 1 .634-.223c.25-.051.51-.051 1.03-.051H23.5c1.4 0 2.1 0 2.635-.273a2.5 2.5 0 0 0 1.092-1.092C27.5 23.1 27.5 22.4 27.5 21v-4.5c0-1.4 0-2.1-.273-2.635a2.5 2.5 0 0 0-1.092-1.092C25.6 12.5 24.9 12.5 23.5 12.5h-7c-1.4 0-2.1 0-2.635.273a2.5 2.5 0 0 0-1.092 1.092C12.5 14.4 12.5 15.1 12.5 16.5v5.167c0 .775 0 1.162.085 1.48a2.5 2.5 0 0 0 1.768 1.768c.318.085.705.085 1.48.085Z"
    />
  </svg>
)
}
export default SvgComponent
